import React, { Fragment } from 'react'
import moment from 'moment'
import StarReviewComponent from '../../components/StarReviewComponent'
import Button from '../../components/Button'
import ReviewsModal from './ReviewsModal'
import { sortReviews, formatReviews } from './utils'

import './Reviews.css'

class Reviews extends React.Component {
  state = {
    showReviewsModal: false
  }

  toggleReviewsModal = () => {
    this.setState(prevState => ({
      showReviewsModal: !prevState.showReviewsModal
    }))
  }

  render() {
    const { product, reviews, quantity, isChef } = this.props
    const { showReviewsModal } = this.state

    if (!reviews || !product) return null

    const _reviews = sortReviews(formatReviews(reviews))

    return (
      <Fragment>
        <ReviewsModal
          product={product}
          quantity={quantity}
          reviews={_reviews}
          isOpen={showReviewsModal}
          onRequestClose={() => this.toggleReviewsModal()}
        />

        {_reviews.length ? (
          <section className="reviews-container">
            <div className="title-box">
              <h2 className="title-section">Customer Reviews</h2>
              <div className="review-count-container">
                <p>{parseFloat(product.stars || 0).toFixed(2)}</p>
                <div className="column-container">
                  <StarReviewComponent
                    name="rate"
                    starCount={5}
                    value={product.stars || 0}
                    onStarClick={() => {}}
                  />
                  <p className="total-reviews">
                    Based on <span>{quantity} reviews</span>{' '}
                  </p>
                </div>
              </div>
            </div>
            <div className="slider-container">
              {_reviews.slice(0, 4).map(review => (
                <div className="content" key={review.id}>
                  <div className="info">
                    <div className="stars">
                      <StarReviewComponent
                        name="rate"
                        starCount={5}
                        value={review.stars}
                        onStarClick={() => {}}
                      />
                    </div>
                    <p>{review.detail}</p>
                    <div className="row-reviews">
                      <p>
                        {review.customerName
                          ? review.customerName
                          : review.nickname}
                        <span>
                          {moment(review.createdAt, 'YYYY-MM-DD hh:m:s').format(
                            'MM/DD/YY'
                          )}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {reviews && reviews.length > 4 && (
              <div>
                <Button onClick={() => this.toggleReviewsModal()}>
                  View all reviews
                </Button>
              </div>
            )}
          </section>
        ) : (
          <section className="reviews-container">
            <div className="title-box">
              <h2 className="title-section">No Reviews</h2>
              {!isChef && (
                <p className="no-reviews">
                  Be the first to review the {product.name}. Chefs read each
                  review!
                </p>
              )}
            </div>
          </section>
        )}
      </Fragment>
    )
  }
}

export default Reviews



// WEBPACK FOOTER //
// ./src/components/Reviews/index.js